
//when type = development
//will reference from static config.js
let defaultObj = {
    systemName: 'BOCI HR eForm',
    defaultLocale: 'en',
    apiSystemName: 'eForm',
    apiKey: '7475d3b1b6f84423',
    filePath:"/api/file/" + "lsstore",
    rejectUnauthorized: false,
    /* DEV */
    serverBase: '/',
    // servexrURI: '/eform/api',
    // serverURI: 'http://localhost/BOCI_eForm/API',
    serverURI: 'http://localhost:5000', //'https://lsworktesting.azurewebsites.net', 
    authMethod: 'SIMPLE', // auth method, AD or SIMPLE
    // logApplicationError: true, // true if log api application error in console
    /* DEV */
    /* PRD */
    //serverBase: '/web',
    // serverURI: '/api',
    // authMethod: 'AD', // auth method, AD or SIMPLE
    logApplicationError: false, // true if log api application error in console
    /* PRD */
    jqueryDatePickerDateFormat: 'dd-M-yy', // jquery datetime picker date format
    dateFormat: 'dd-mmm-yyyy', // pickadate date format
    monthFormat: 'mmm-yyyy', // pickadate month format
    momentDateFormat: 'DD-MMM-YYYY', // moment date format
    momentMonthFormat: 'MMM-YYYY', // moment date format
    momentDateTimeFormat: 'YYYY-MM-DD HH:mm:ss', // moment datetime format
    momentTimeFormat: 'HH:mm', // moment time format
    momentDBDateFormat: 'YYYY-MM-DD', // convert moment date format to database format
    momentDBMonthFormat: 'YYYY-MM', // convert moment date format to database format
    emptyText: 'Not Yet Input', // Empty text used in data table link column if not text is entered
    dataTablePageLength: 20,
    tablePageLength: 20,
    sessionWarn: 25, // session timeout warning in minutes, default to 25
    sessionTimeout: 30, // session timeout in minutes, default to 30
    requestTimeout: 0.5 , 
    fileUploadLimit: 10, // file upload limit in MB
    fileUploadAllowedExtensions: ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx', 'xlsx', 'xls'], // Array of allowed extensions
    notificationTimeout: 2500, // Notification appear ms before hiding,
    minWidth: 1200, // Minimum width
    minHeight: 600, // Minimum height
    region:"Australia/Sydney",
}


export default defaultObj


